<ms-preview
  [package]="package"
  mode="READ"
  [attr.data-testid]="'coupon-preview'"
>
</ms-preview>
